export default __webpack_public_path__ + "static/media/a-icon-email.36633f46.svg";